export default "__VITE_ASSET__dc187987__"